// Discriminates a search document by its stored shape.
// Centralises the field-presence checks that were previously
// duplicated across TopNavSearchBar, SearchResultsContainer,
// and SectionHomeAddToClassCell.

// @returns {'repo' | 'folder' | 'set' | 'question' | null}
export function getDocumentType(document) {
  if (!document) return null
  if (document.createdBy !== undefined) return 'repo'
  if (document.ancestors !== undefined) return 'folder'
  if (document.questions !== undefined) return 'set'
  if (document.choices !== undefined) return 'question'
  return null
}
